document.addEventListener("DOMContentLoaded", () => {
    // Detect if running in Electron (has window.electronAPI or uses file:// protocol)
    const isElectron = typeof window !== 'undefined' &&
        ((window as unknown as { electronAPI?: unknown }).electronAPI !== undefined ||
         window.location.protocol === 'file:');

    // Detect local development environments
    const isLocalDev = window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.endsWith('.railway.app');

    // In Electron or local dev: keep local links (author.html)
    // In production web (Vercel, etc.): redirect to external domains
    const isLocal = isElectron || isLocalDev;

    // Configuration from .env (Manual Mirror)
    // If we are effectively in "Production" mode (not local), use these domains
    const PROD_STUDIO_URL = "https://starlightweavelabs.eu/author.html";
    const PROD_GAME_URL = "https://aetherweave-gambit.eu";

    if (!isLocal) {
        // Update Studio Link on Landing Page (Vercel: go to external studio site)
        const studioLink = document.getElementById('nav-studio-link') as HTMLAnchorElement | null;
        if (studioLink !== null && studioLink !== undefined) {
            studioLink.href = PROD_STUDIO_URL;
        }

        // Update Hub Link on Author/Studio Page (Vercel: go to external game site)
        const hubLink = document.getElementById('nav-hub-link') as HTMLAnchorElement | null;
        if (hubLink !== null && hubLink !== undefined) {
            hubLink.href = PROD_GAME_URL;
        }
    }
    // In Electron/local: links stay as author.html (default from HTML)
});
